module.exports = __webpack_public_path__ + "img/feature4.b9f478f.png";